/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Switch from "@mui/material/Switch";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import profileImage from "assets/images/logo-ct.png";
import backgroundImage from "assets/images/bg-profile.jpeg";

import { getUserInfo } from "domain/apis/userService";
//import { } from 'domain/apis/twoFactorAuthencatorService';

function Header({ children, onChangePassword, onTfa }) {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [userInfo, setUserInfo] = useState({});

  useEffect(() => {
    getUserInfo().subscribe({
      next: ({ data }) => {
        setUserInfo(data?.data ?? {});
        setTwoFactor(data?.data?.enabledTwoFactor ?? false);
      },
    });
  }, []);

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const [twoFactor, setTwoFactor] = useState(false);

  return (
    <MDBox position="relative" mb={5}>
      <MDBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="18.75rem"
        borderRadius="xl"
        sx={{
          backgroundImage: ({
            functions: { rgba, linearGradient },
            palette: { gradients },
          }) =>
            `${linearGradient(
              rgba(gradients.info.main, 0.6),
              rgba(gradients.info.state, 0.6)
            )}, url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}
        style={{ padding: 24 }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar
              src={profileImage}
              alt="profile-image"
              size="xl"
              shadow="sm"
            />
          </Grid>
          <Grid item>
            <MDBox height="100%" mt={0.5} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                {userInfo?.fullName}
              </MDTypography>
              <MDTypography variant="button" color="text" fontWeight="regular">
                {userInfo?.email}
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>
        <br />
        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
          <button
            onClick={() => {
              if (onChangePassword) {
                onChangePassword(true);
              }
            }}
            style={{ border: 0, backgroundColor: "transparent" }}
          >
            <MDBadge
              badgeContent="Thay đổi mật khẩu"
              color="info"
              variant="gradient"
              size="sm"
            />
          </button>
        </MDBox>
        <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
          <MDBox mt={0.5}>
            <Switch
              checked={twoFactor}
              onChange={() => {
                onTfa(twoFactor);
              }}
            />
          </MDBox>
          <MDBox width="80%" ml={0.5}>
            <MDTypography variant="button" fontWeight="regular" color="text">
              Bảo mật 2 yếu tố
            </MDTypography>
          </MDBox>
        </MDBox>
        {children}
      </Card>
    </MDBox>
  );
}

// Setting default props for the Header
Header.defaultProps = {
  children: "",
};

// Typechecking props for the Header
Header.propTypes = {
  children: PropTypes.node,
};

export default Header;
